export type AdaptiveBuildExecutionMode = 'direct_full_ledger' | 'cluster_backbone' | 'large_n_incremental' | 'gated_witness_enrollment' | 'plan_only'

const DIRECT_FULL_LEDGER_STRATEGIES = new Set([
  'single_witness_segmentation',
  'pairwise_alignment',
  'small_n_joint_collation',
])

export const getAdaptiveBuildExecutionMode = (strategy: string | null | undefined): AdaptiveBuildExecutionMode => {
  if (!strategy) {
    return 'plan_only'
  }
  if (DIRECT_FULL_LEDGER_STRATEGIES.has(strategy)) {
    return 'direct_full_ledger'
  }
  if (strategy === 'cluster_representative_backbone') {
    return 'cluster_backbone'
  }
  if (strategy === 'large_n_incremental_enrollment') {
    return 'large_n_incremental'
  }
  if (strategy === 'divergent_multi_backbone') {
    return 'gated_witness_enrollment'
  }
  return 'plan_only'
}

export const canExecuteAdaptiveBuildStrategy = (strategy: string | null | undefined): boolean => (
  getAdaptiveBuildExecutionMode(strategy) !== 'plan_only'
)
